"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _unique = function _unique(definitions) {
  var names = {};
  return definitions.filter(function (definition) {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }

    var name = definition.name.value;

    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};

import { useCallback } from 'react';
import { useMutationWithValidation } from '../../useMutationWithValidation';
import { authStatus } from '../AuthStatus/authStatus';
export var UPDATE_PROFILE = {
  "kind": "Document",
  "definitions": /*#__PURE__*/_unique( /*#__PURE__*/[{
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "UserProfileInput"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "REST"
      }
    },
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "firstName"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "surname"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "email"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "password"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "currentPassword"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "locale"
        },
        "name": {
          "kind": "Name",
          "value": "String"
        },
        "arguments": [],
        "directives": []
      }]
    }
  }, {
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateProfile"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "input"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "UserProfileInput"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateProfile"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "input"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "input"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "rest"
          },
          "arguments": [{
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "type"
            },
            "value": {
              "kind": "StringValue",
              "value": "AuthStatus",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "method"
            },
            "value": {
              "kind": "StringValue",
              "value": "PUT",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "endpoint"
            },
            "value": {
              "kind": "StringValue",
              "value": "v2",
              "block": false
            }
          }, {
            "kind": "Argument",
            "name": {
              "kind": "Name",
              "value": "path"
            },
            "value": {
              "kind": "StringValue",
              "value": "member/profile",
              "block": false
            }
          }]
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "FragmentSpread",
            "name": {
              "kind": "Name",
              "value": "AuthStatus"
            },
            "directives": []
          }]
        }
      }]
    }
  }].concat(authStatus.definitions)),
  "loc": {
    "start": 0,
    "end": 381,
    "source": {
      "body": "\n  fragment UserProfileInput on REST {\n    firstName: String\n    surname: String\n    email: String\n    password: String\n    currentPassword: String\n    locale: String\n  }\n\n  mutation updateProfile($input: UserProfileInput!) {\n    updateProfile(input: $input)\n      @rest(type: \"AuthStatus\", method: \"PUT\", endpoint: \"v2\", path: \"member/profile\") {\n      ...AuthStatus\n    }\n  }\n  \n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var useUpdateProfileMutation = function useUpdateProfileMutation(options) {
  var _useMutationWithValid = useMutationWithValidation(UPDATE_PROFILE, _objectSpread(_objectSpread({}, options), {}, {
    ignoreResults: true
  })),
      _useMutationWithValid2 = _slicedToArray(_useMutationWithValid, 1),
      mutate = _useMutationWithValid2[0];

  return [useCallback(function (input) {
    return mutate({
      variables: {
        input: input
      }
    });
  }, [mutate])];
};